const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

export function isProbablyHtml(value) {
  return HTML_TAG_PATTERN.test(String(value || ''));
}

export function plaintextToEmailHtml(value) {
  const text = String(value || '').replace(/\r\n/g, '\n').trim();
  if (!text) return '';

  return text
    .split(/\n{2,}/)
    .map((paragraph) => {
      const escaped = paragraph
        .split('&').join('&amp;')
        .split('<').join('&lt;')
        .split('>').join('&gt;')
        .replace(/\n/g, '<br/>');
      return `<p>${escaped}</p>`;
    })
    .join('');
}

export function normalizeEmailBodyHtml(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return isProbablyHtml(text) ? text : plaintextToEmailHtml(text);
}

export function htmlToPlainText(value) {
  const html = String(value || '').trim();
  if (!html) return '';
  if (!isProbablyHtml(html)) return html;

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return (doc.body.innerText || '')
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
